var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiShOdKu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(-35.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D2F1FF",
    x: 0,
    y: 0,
    width: 370.084811,
    height: 277.563608
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.839908,189.90898 C147.30701,189.90898 116.876721,220.096914 116.876721,257.338897 L116.876721,283.033654 C137.176428,293.68583 160.28249,299.777907 184.839908,299.777907 C209.402144,299.777907 232.508207,293.68583 252.803096,283.033654 L252.803096,257.338897 C252.803096,220.096914 222.377624,189.90898 184.839908,189.90898",
    id: "Fill-4",
    fill: "#2593FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.190208,109.994388 C126.190208,77.8662294 152.449506,51.8210847 184.841835,51.8210847 C217.234164,51.8210847 243.493462,77.8662294 243.493462,109.994388 C243.493462,142.122547 217.234164,168.166497 184.841835,168.166497 C152.449506,168.166497 126.190208,142.122547 126.190208,109.994388",
    id: "Fill-6",
    fill: "#25BBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiShOdKu);
export default __webpack_public_path__ + "static/media/JiShOdKU.e141a1b9b8fea83b48cb9ff2e204eb5e.svg";
export { ForwardRef as ReactComponent };